// eslint-disable-next-line import/prefer-default-export
export const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 0 },
    items: 3,
    slidesToSlide: 3,
  },
};
